import {NextPageContext} from "next";
import {useTranslation} from "ni18n";
import React, {useEffect} from "react";
import {useDispatch} from "react-redux";

import {api} from "../_services/api";
import {covidReadyUrl} from "../components/_common/_constants";
import Footer from "../components/v5/CovidReadyForOrgs/Footer";
import Header from "../components/v5/CovidReadyForOrgs/Header";
import Hero from "../components/v5/CovidReadyForOrgs/Hero";
import How from "../components/v5/CovidReadyForOrgs/How";
import Layout from "../components/v5/Layout";
import {actions, useTypedSelector} from "../store";

const supportEmails = {
  brookfield: "brookfield-support@carbonhealth.com",
  "mcmaster-carr": "mcmaster-carr-support@carbonhealth.com",
  boltthreads: "boltthreads-support@carbonhealth.com",
  bridgebio: "bridgebio-support@carbonhealth.com",
  "maze-therapeutics": "maze-support@carbonhealth.com",
  senti: "senti-support@carbonhealth.com",
  "carbon-health-technology": "carbonites-cr-support@carbonhealth.com",
  alto: "alto-support@carbonhealth.com",
};

const CovidReadyForOrgs = ({landingPageData, orgSlug}: any) => {
  const i18n = useTranslation();
  const {imgExt, pageLoaded, isMobile} = useTypedSelector(({config}) => config);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.setConfig({
        pageLoaded: true,
        // locationsSorted: true,
      }),
    );
  }, []);

  return (
    <Layout
      noIndex
      pageTitle={i18n.t(
        "Get your workforce Covid Ready | Coronavirus Testing for Businesses at Carbon Health",
      )}
      pageDescription={i18n.t(
        "Get your employees tested for Coronavirus and back to work with Covid Ready by Carbon Health. On-site testing, at-home testing, and workforce management; open for business safely. ",
      )}
      noHeader
      noFooter
      pageImage="covid-ready"
    >
      <Header {...{pageLoaded, isMobile}} />
      <Hero {...{pageLoaded, imgExt, landingPageData}} />
      <How />
      <Footer
        {...{
          pageLoaded,
          imgExt,
          landingPageData,
          // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ brookfield: string; "mcmaster-carr": string; boltthreads: string; bridgebio: string; "maze-therapeutics": string; senti: string; "carbon-health-technology": string; alto: string; }'.
          supportEmail: supportEmails[orgSlug] || "carbonites-cr-support@carbonhealth.com",
        }}
      />
    </Layout>
  );
};

CovidReadyForOrgs.getInitialProps = async ({query: {orgSlug}}: NextPageContext) => ({
  landingPageData: (await api.get(`/hib/organizations/${orgSlug}/landingPageData`)) || {
    name: "Your company",
    ctaLink: covidReadyUrl,
  },
  orgSlug,
});

export default CovidReadyForOrgs;
